import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Action Types
import { FORGET_PASSWORD } from "./actionTypes"
import { delay } from "redux-saga/effects";

// Actions
import { userForgetPasswordSuccess, userForgetPasswordError, clearForgetPasswordMessage } from "./actions"

// API Helper
import { postJwtForgetPwd } from "../../../helpers/fakebackend_helper"
import axios from "axios"

// ========== SAGA FUNCTION ==========
function* forgetUser({ payload: { user, history } }) {
  try {
    // user = { email, password }
    const data = {
      email: user.email,
      password: user.password,
    };

    // Call your API (change endpoint to your backend API)
    const response = yield call(axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/resetPassword/admin/`, data);

    if (response?.status === 200 || response?.success) {
      yield put(
        userForgetPasswordSuccess("Password has been reset successfully")
      );

      yield delay(5000);
      if (history) history("/login");

      // Remove message after 10 seconds
      yield delay(5000); // 5 sec + 5 sec = 10 sec total
      yield put(clearForgetPasswordMessage());
    } else {
      yield put(
        userForgetPasswordError(
          response?.message || "Something went wrong while resetting password."
        )
      );
    }
  } catch (error) {
    yield put(
      userForgetPasswordError(
        error?.response?.data?.message || "Server error. Try again later."
      )
    );
  }
}

// ========== WATCHER ==========
export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser);
}

// ========== ROOT SAGA ==========
function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)]);
}

export default forgetPasswordSaga;
